<section class="wrapper">
  <section mat-dialog-title>
    <button mat-dialog-close mat-icon-button matTooltip="Close.">
      <mat-icon>close</mat-icon>
    </button>
    <h1>
      <mat-icon>view_list</mat-icon>
      Purchases | {{title}} - {{ Item.title }}
      @if (loading) {
        <mat-icon class="loading">autorenew</mat-icon>
      }
    </h1>
  </section>
  <section mat-dialog-content>
    <mat-table #table [dataSource]="Data" class="mat-ticket-table">
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns;"
        [ngClass]="{disabled: row.status != 'authorised'}"
      ></tr>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>&nbsp;</th>
        <td mat-cell *matCellDef="let row" class="icon">
          <mat-icon>{{ row.icon }}</mat-icon>
        </td>
      </ng-container>
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Name</th>
        <td mat-cell *matCellDef="let row">{{ row.name }}</td>
      </ng-container>
      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef>Email</th>
        <td mat-cell *matCellDef="let row">{{ row.email}}</td>
      </ng-container>
      <ng-container matColumnDef="total_tickets">
        <th mat-header-cell *matHeaderCellDef>Total Items</th>
        <td mat-cell *matCellDef="let row">{{ row.total_tickets}}</td>
      </ng-container>
      <ng-container matColumnDef="notes">
        <th mat-header-cell *matHeaderCellDef>Notes</th>
        <td mat-cell *matCellDef="let row">{{ row.notes}}</td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row">
          <button
            (click)="editOrderNotes(row)"
            [ngClass]="{'has-note' : !!row?.notes}"
            class="edit-note"
            mat-icon-button
            matTooltip="Update order notes."
            >
            <mat-icon
              >{{ row?.notes && 'insert_comment' || 'add_comment' }}</mat-icon
              >
            </button>
            <button
              (click)="refundOrder(row)"
              [disabled]="row.status == 'refunded'"
              mat-icon-button
              matTooltip="Refund order."
              >
              <mat-icon>remove_shopping_cart</mat-icon>
            </button>
          </td>
        </ng-container>
      </mat-table>
      @if (PageEvent) {
        <mat-paginator
          (page)="loadPage($event)"
          [hidePageSize]="true"
          [length]="PageEvent.length"
          [pageIndex]="PageEvent.pageIndex"
          [pageSize]="PageEvent.pageSize"
        ></mat-paginator>
      }
    </section>
    <section align="end" mat-dialog-actions>
      <button
        (click)="downloadCSV()"
        [disabled]="loading || csvExportLoading || !hasAuthorisedPurchase"
        mat-button
        matTooltip="Download."
        >
        <mat-icon>file_download</mat-icon>
        {{ csvExportLoading ? 'Downloading CSV' : 'Download CSV' }}
      </button>
      <button
        (click)="downloadPDF()"
        [disabled]="loading || pdfExportLoading || !hasAuthorisedPurchase"
        mat-button
        matTooltip="Download."
        >
        <mat-icon>save</mat-icon>
        {{ pdfExportLoading ? 'Downloading PDF' : 'Download PDF' }}
      </button>
    </section>
  </section>
